import React from 'react';

import { TIntl } from 'types/intl';

export const IntlContext = React.createContext<null | TIntl>(null);
